import { SWMS_TASK_URL, SWMS_CATEGORY_MANAGEMENT_URL, ALL_JOB_SWMS_URL, UPDATE_SWMS_SELECTION, SWMS_TASK_COPY_URL, SWMS_TASK_DELETE_URL, SWMS_APPROVE_ALL_ADMINS_URL, SWMS_SEND_MANAGER_APPROVAL_URL, SWMS_APPROVE_REJECT_URL, SWMS_CREATE_VERSION_URL, PREVIEW_SWMS, SWMS_GET_SITE_TASK_SWMS_URL, SWMS_SIGN_HISTORY_URL, SWMS_DRAFT_SEND_APPROVAL_URL } from "../../dataProvider/constant";
import { baseApiInstance, scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

export const getSwmsTask = (abortController, job_id) => () => {
  return scopeApiInstance.get(SWMS_TASK_URL, { ...abortController, params: { job_id: job_id } }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getSwmsCategories = (abortController, params) => () => {
  return scopeApiInstance.get(SWMS_CATEGORY_MANAGEMENT_URL, { ...abortController, params: { ...params } }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getAllJobSwms = (abortController, jobId) => () => {
  return scopeApiInstance.get(`${ALL_JOB_SWMS_URL}/${jobId}`, { ...abortController }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }

  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const generateWhsPack = (jobId, shiftId, swmsId) => () => {
  return scopeApiInstance.post(
    `${ALL_JOB_SWMS_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/whs-pack`,
    {}
  ).then((res) => {
    if (res && res.data) {
      return Promise.resolve(res.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => Promise.reject(
    error && error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : Strings.network_error
  ));
};

export const createSwmsDraft = (abortController, jobId, swmsData) => () => {
  return scopeApiInstance.post(`${ALL_JOB_SWMS_URL}/${jobId}`, swmsData, { ...abortController }).then((res) => {
    if (res && res.data) {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const updateSwmsSelection = (formData, isAdding = false) => () => {
  return scopeApiInstance.post(UPDATE_SWMS_SELECTION, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject();
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const copySwms = (formData) => () => {
  return scopeApiInstance.post(SWMS_TASK_COPY_URL, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const deleteSwms = (swmsFormId) => () => {
  return scopeApiInstance.delete(SWMS_TASK_DELETE_URL, { params: { swms_form_id: swmsFormId } }).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const deleteSwmsDraftV2 = (jobId, swmsId) => () => {
  if (!jobId || !swmsId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.delete(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}`).then((res) => {
    if (res && res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.resolve("SWMS deleted successfully.");
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  });
}

export const copySwmsDraftV2 = (jobId, swmsId) => () => {
  if (!jobId || !swmsId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.post(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/copy`, {}).then((res) => {
    if (res && res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.resolve("SWMS copied successfully.");
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  });
}

export const getSwmsDraftVersionsV2 = (abortController, jobId, swmsId) => () => {
  if (!jobId || !swmsId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.get(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/versions`, { ...abortController }).then((res) => {
    if (res && res.data && Array.isArray(res.data.data)) {
      return Promise.resolve(res.data.data);
    }

    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  });
}

export const getSwmsAdmins = (orgId) => () => {
  return baseApiInstance.get(SWMS_APPROVE_ALL_ADMINS_URL, { params: { organisation_id: orgId } }).then(res => {
    let data = res.data.data;
    if (data && data.admins) {
      return Promise.resolve(data.admins)
    }
    else {
      return Promise.reject(Strings.generic_error)
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const sendSwmsForManagerApproval = (formData) => () => {
  return scopeApiInstance.post(SWMS_SEND_MANAGER_APPROVAL_URL, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject();
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const approveRejectSwms = (formData) => () => {
  return scopeApiInstance.put(SWMS_APPROVE_REJECT_URL, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject();
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const createNewSwms = (formData) => () => {
  return scopeApiInstance.post(SWMS_CREATE_VERSION_URL, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject();
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const getApprovedSiteSwms = (abortController, params = {}) => () => {
  return scopeApiInstance.get(SWMS_GET_SITE_TASK_SWMS_URL, { ...abortController, params: { ...params } }).then(res => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getSignHistory = (params = {}, abortController) => () => {
  return scopeApiInstance.get(SWMS_SIGN_HISTORY_URL, { ...abortController, params: { ...params } }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const sendSwmsDraftForApproval = (formData) => () => {
  return scopeApiInstance.post(SWMS_DRAFT_SEND_APPROVAL_URL, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}

export const sendSwmsDraftForApprovalV2 = (jobId, swmsId, formData) => () => {
  if (!jobId || !swmsId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.post(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/submit`, formData).then((res) => {
    if (res && res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  });
}

export const cancelSwmsApprovalV2 = (jobId, swmsId) => () => {
  if (!jobId || !swmsId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.post(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/cancel-approval`, {}).then((res) => {
    if (res && res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.resolve("Approval cancelled successfully.");
    }
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  });
}

export const resendSwmsReviewerV2 = (jobId, swmsId, formData) => () => {
  if (!jobId || !swmsId || !formData) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.post(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/submit/resend`, formData).then((res) => {
    if (res && res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    }

    return Promise.resolve("Approval link resent successfully.");
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  });
}

export const cancelSwmsApproverV2 = (jobId, swmsId, formData) => () => {
  if (!jobId || !swmsId || !formData) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.post(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/cancel-approver`, formData).then((res) => {
    if (res && res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    }

    return Promise.resolve("Approver cancelled successfully.");
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  });
}

export const revertSwmsDraftVersionV2 = (jobId, swmsId, version) => () => {
  if (!jobId || !swmsId || !version || Number.isNaN(Number(version))) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.post(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/revert`, {
    version: Number(version)
  }).then((res) => {
    if (res && res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    }

    return Promise.resolve("Version reverted successfully.");
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  });
}

export const updateSwmsVisibilityV2 = (jobId, swmsId, visible) => () => {
  if (!jobId || !swmsId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.patch(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/visibility`, {
    visible: visible === true
  }).then((res) => {
    if (res && res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    }

    return Promise.resolve(visible === true ? "SWMS is now visible on site." : "SWMS is now hidden from site.");
  }).catch((error) => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  });
}